export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11302.e48a79e7.jpg";